<template>
  <div class="remenluxian">
    <div @click="$router.go(-1)" class="btn-icon back-btn">
      <div>
        <img src="../assets/back.png" />
      </div>
      <div>返回客情</div>
    </div>
    <div class="save-line">
      <div class="icon"></div>
      <div class="text">保存路线</div>
    </div>
    <div>
      <MapTitle :data="mapTitleData" @getCurTab="setCurtab" />
      <Linemap :legendColor="legendColor" :legendConf="RemenLuxianDetailData.legendConf" :lineData="RemenLuxianDetailData.lineData" :title="RemenLuxianDetailData.title" />
    </div>
    <div class="left-content" id="remenluxianTable">
      <ol class="tab">
        <li :class="{ current: tableTab == 0 }" @click="tableTab = 0">全部</li>
        <li :class="{ current: tableTab == 1 }" @click="tableTab = 1">二级</li>
        <li :class="{ current: tableTab == 2 }" @click="tableTab = 2">三级</li>
        <li :class="{ current: tableTab == 3 }" @click="tableTab = 3">四级</li>
        <li :class="{ current: tableTab == 4 }" @click="tableTab = 4">五级</li>
      </ol>
      <BaseTable :data="tableData" height="calc(100% - 0.9rem)"/>
      <!-- <div class="sure">确定</div> -->
    </div>
    <div @click="controlPanel" class="control-panel">
      <div :class="['icon', { icon2: !panelFlag }]"></div>
      <div class="text">点击{{ panelFlag ? "收起" : "打开" }}面板</div>
    </div>
    <div class="legend my-amap-legend">
      <div class="title">路线热度值</div>
      <ul>
        <li :key="index" v-for="(item, index) in RemenLuxianDetailData.legendConf">
          <div class="rect">
            <div :style="{
                height:
                  (RemenLuxianDetailData.legendConf.length - index) * 0.01 +
                  'rem',
                background: legendColor[index],
                boxShadow: '0 0 5px ' + legendColor[index]
              }" class="rect-in"></div>
          </div>
          <div class="num">{{ item.max ? item.min + "-" + item.max : ">" + item.min }}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Linemap from '@/components/Loca/Linemap.vue'
import MapTitle from '@/components/Common/MapTitle.vue'
import BScroll from '@/components/Common/BScroll.vue'
import BaseTable from '@/components/Common/BaseTable.vue'

export default {
  name: 'RemenLuxian',
  components: {
    MapTitle,
    Linemap,
    BScroll,
    BaseTable
  },
  props: {
    RemenLuxianDetailData: {
      type: Object
    }
  },
  computed: {
    tableData() {
      var temp = {
        tableHeaderWidth: ['20%', '60%', '20%'],
        tableHeader: ['Top值', '热门路线', '热度'],
        tableBody: []
      }
      this.RemenLuxianDetailData.lineData.forEach((el, index) => {
        temp.tableBody.push(['Top' + (index + 1), el.name, el.hot])
      })
      return temp;
    }
  },
  data() {
    return {
      tableTab: 0,
      curMap: 0,
      mapTitleData: {
        title: '2019年7月城市热门路线',
        tab: ['城市级别', '景区级别', '热门景区']
      },
      panelFlag: true,
      legendColor: ['#DA221A', '#FF852F', '#F5E047', '#6BF15c', '#34B7ED']
    }
  },
  mounted() {},
  methods: {
    controlPanel() {
      if (this.panelFlag) {
        document.getElementById('remenluxianTable').style.width = 0
      } else {
        document.getElementById('remenluxianTable').style.width = '4.24rem'
      }
      this.panelFlag = !this.panelFlag
    },
    randomFrom(lowerValue, upperValue) {
      return Math.floor(
        Math.random() * (upperValue - lowerValue + 1) + lowerValue
      )
    },
    setCurtab(val) {
      this.curMap = val
    }
  }
}
</script>
<style scoped lang="less">
.remenluxian {
  .back-btn {
    left: 0.6rem;
    top: 0.8rem;
  }
  .save-line {
    position: absolute;
    right: 0.8rem;
    top: 0.86rem;
    width: 1.18rem;
    height: 0.36rem;
    line-height: 0.36rem;
    z-index: 9999;
    > div {
      float: left;
    }
    .icon {
      width: 0.36rem;
      height: 0.36rem;
      background: url(../assets/remenluxian/save.png);
      background-size: 100% 100%;
    }
  }
  .control-panel {
    width: 0.6rem;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
    .icon {
      width: 0.38rem;
      height: 0.46rem;
      background: url(../assets/remenluxian/arrow.png);
      background-size: 100% 100%;
      margin: 0 auto;
    }
    .icon2 {
      transform: rotate(180deg);
    }
    .text {
      width: 0.16rem;
      font-size: 0.16rem;
      margin: 0 auto;
    }
  }
  .left-content {
    transition: 0.3s;
    width: 4.24rem;
    height: 84%;
    left: 0.6rem;
    top: 1.24rem !important;
    overflow: hidden;
    .sure {
      margin: 0.1rem auto 0;
      width: 0.56rem;
      height: 0.21rem;
      line-height: 0.2rem;
      border-radius: 1rem;
      border: 1px solid @light-blue;
      color: @light-blue;
      font-size: 0.16rem;
      cursor: pointer;
    }
    .tab {
      width: 3.5rem;
      height: 0.3rem;
      margin: 0 auto 0.16rem;
      > li {
        float: left;
        width: 20%;
        height: 0.3rem;
        line-height: 0.3rem;
        cursor: pointer;
      }
      .current {
        color: @light-blue;
        border-bottom: 1px solid @light-blue;
        background-image: linear-gradient(
          to top,
          rgba(0, 84, 178, 0.4),
          rgba(34, 84, 178, 0.05)
        );
      }
    }
  }
}
</style>
